import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const C = {
  bg: '#0F0F0F',
  bdr: '#2A2A2A',
  accent: '#D97757',
  text: '#F0EDE8',
};

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    // If user data was passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsAuthenticated(true);
      return;
    }

    // CRITICAL: Skip /me check if returning from OAuth callback
    // AuthCallback will handle authentication in that case
    if (window.location.hash?.includes('session_id=')) {
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Not authenticated');
        }

        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
        navigate('/login');
      }
    };

    checkAuth();
  }, [location.state, navigate]);

  // null = checking, true = authenticated, false = not authenticated
  if (isAuthenticated === null) {
    return (
      <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 24, height: 24, border: `1.5px solid ${C.bdr}`, borderTopColor: C.accent, borderRadius: '50%', animation: 'spin .7s linear infinite' }} />
          <span style={{ fontSize: 12, color: C.text, fontFamily: 'JetBrains Mono, monospace' }}>Loading...</span>
          <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  // Pass user to children
  return <>{typeof children === 'function' ? children(user) : children}</>;
}
